define('models/shared/settings/settingvalue_collection',["backbone",
        "models/shared/settings/settingvalue"
], function (Backbone, Setting) {
    var settingList = Backbone.Collection.extend({
        url: function () {
            switch (this.SF) {
                case pf.enums.settingFor.Account:
                    return pf.accountsURL + "/" + this.ID + "/Settings";
                    break;
                case pf.enums.settingFor.User:
                    return pf.userURL + "/Settings";
                    break;
            }
        },
         initialize: function (options) {
            options = options || {};
            this.ID = options.ID;
            this.SF = options.SF;
        },
        model: Setting
    });
    return settingList;
});

